var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 36.0107C22.8845 35.4761 26.2653 34.9843 28.3409 33.3592C30.7803 31.4562 31.3581 27.9708 32 21C32.6633 28.2274 33.2625 31.6914 35.9372 33.5517C38.0128 35.0057 41.3723 35.4761 47 35.9893C41.1369 36.5239 37.7347 37.0157 35.6805 38.6194C33.2197 40.5438 32.6419 44.0078 32 51C31.4009 44.5638 30.8659 41.1212 28.8759 39.1326C26.8859 37.144 23.4194 36.588 17 36.0107Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18526e-06 26.0036C1.96149 25.8254 3.08845 25.6614 3.78031 25.1197C4.59344 24.4854 4.78602 23.3236 5 21C5.22111 23.4091 5.42083 24.5638 6.31241 25.1839C7.00428 25.6686 8.12411 25.8254 10 25.9964C8.04565 26.1746 6.91155 26.3386 6.22682 26.8731C5.40656 27.5146 5.21398 28.6693 5 31C4.80029 28.8546 4.62197 27.7071 3.95863 27.0442C3.29529 26.3813 2.1398 26.196 2.18526e-06 26.0036Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.0057C17.1384 7.7206 18.9415 7.4583 20.0485 6.59159C21.3495 5.57662 21.6576 3.71774 22 -2.18557e-06C22.3538 3.8546 22.6733 5.70207 24.0999 6.69423C25.2069 7.46971 26.9986 7.7206 30 7.9943C26.873 8.2794 25.0585 8.5417 23.9629 9.397C22.6505 10.4234 22.3424 12.2708 22 16C21.6805 12.5674 21.3952 10.7313 20.3338 9.67071C19.2725 8.61012 17.4237 8.31361 14 8.0057Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.283399e4c2265dde151152a96c3c7d66.svg";
export { ForwardRef as ReactComponent };